import { AgentMessage_Role, AgentMessage_Type } from "gitpod-next-api/gitpod/v1/agent_pb";

export function truncateName(name: string, maxLength = 50): string {
    if (name.length <= maxLength) return name;
    return name.slice(0, maxLength - 1) + "…";
}

/**
 * Resolves a display name from an agent execution name.
 * Falls back to "Agent" if unavailable.
 */
export function resolveAgentDisplayName(executionName: string | undefined): string {
    if (!executionName) return "Agent";
    return truncateName(executionName);
}

export function getAgentMessageBadgeLabel(
    role: AgentMessage_Role,
    messageType: AgentMessage_Type,
    displayName: string,
): string {
    if (role === AgentMessage_Role.PARENT) {
        return `Ask from ${displayName}`;
    }
    // role is CHILD or UNSPECIFIED — treat as child
    if (messageType === AgentMessage_Type.COMPLETE) {
        return `${displayName} completed`;
    }
    return `Update from ${displayName}`;
}
